import { TeamForFilter } from '../types';
import { getFilterOptions } from './get-filtered-options';

export const getIsAllOptionsSelected = (
  teams: TeamForFilter[],
  selectedUserIds: number[],
): boolean => {
  if (teams?.length > 0) {
    // Combine all user IDs from both team and user types
    const allUserIds = teams.reduce((userIds, team) => {
      if (team.type === 'team') {
        // Add user IDs from team type
        userIds.push(...team.users.map((user) => user.id));
      } else if (team.type === 'user') {
        // Add user ID from user type
        userIds.push(team.id);
      }
      return userIds;
    }, []);

    // Check if all user IDs are in selectedUserIds
    return allUserIds.every((userId) => selectedUserIds.includes(userId));
  }
  return false;
};

export const getIsSelectAllCheckboxChecked = (
  teams: TeamForFilter[],
  selectedUserIds: number[],
  search: string,
) => {
  if (teams?.length > 0) {
    const filteredOptions = getFilterOptions(teams, search);

    // Combine all user IDs from both team and user types
    const allUserIds = filteredOptions.reduce((userIds, team) => {
      if (team.type === 'team') {
        // Add user IDs from team type
        userIds.push(...team.users.map((user) => user.id));
      } else if (team.type === 'user') {
        // Add user ID from user type
        userIds.push(team.id);
      }
      return userIds;
    }, []);

    // Check if all user IDs are in selectedUserIds
    return {
      isSelectAllCheckboxChecked: allUserIds.every((userId) =>
        selectedUserIds.includes(userId),
      ),
      intermediate: allUserIds.some((userId) =>
        selectedUserIds.includes(userId),
      ),
    };
  }
  return {
    isSelectAllCheckboxChecked: false,
    intermediate: false,
  };
};
